import styled from 'styled-components';

export const Title = styled.div`
  justify-content: center;
  font-style: bold;
  font-weight: 700;
  font-size: 16px;
`;

export const Action = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  text-decoration-line: underline;
  align-items: center;
  gap: 8px;
`;

export const BannerNotificationContainer = styled.div`
  position: sticky;
  top: 74px;
  z-index: 99;
  display: flex;
  padding: 0px 16px;
  background: ${props => (props.overdueBill ? 'red' : 'orange')};
  height: 48px
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
`;
